export default "__VITE_ASSET__R0g3t62L__"